import { canUserUpdateInquiries } from "./Poll";
import { isUserSuperUser } from "./user";
import { redirect } from 'react-router-dom';
import { AdministrationSectionID } from '../interfaces/Administration';

export const accessUpdatePollRoutesLoader = () => {
    if (canUserUpdateInquiries()) return true;
    return redirect('/home/polls');
};

export const checkRouteEnabled = (key: string) => () => {
    if (window.config.HIDE_SIDEBAR_MENU_BUTTONS.includes(key)) return redirect('/');
    if (window.config.DISABLED_SIDEBAR_MENU_BUTTONS.includes(key)) return redirect('/');
    return true;
};

export const canUserAccessAdministration = () => {
    return isUserSuperUser();
};

export const checkAdministrationRouteEnabled = (key: AdministrationSectionID) => () => {
    const hiddenAdministrationButtons = window.config.HIDE_ADMINISTRATION_BUTTONS as AdministrationSectionID[];
    const disabledAdministrationButtons = window.config.DISABLED_ADMINISTRATION_BUTTONS as AdministrationSectionID[];

    if (hiddenAdministrationButtons.includes(key)) return redirect('/home/administration');
    if (disabledAdministrationButtons.includes(key)) return redirect('/home/administration');
    return true;
};

export const accessAdministrationLoader = () => {
    if (canUserAccessAdministration()) return true;
    return redirect('/home/patients');
};

export const checkPatientButtonsEnabled = (key: 'pharmacy' | 'clinical_course') => () => {
    if (window.config.HIDE_PATIENT_BUTTONS.includes(key)) return redirect('../');
    if (window.config.DISABLED_PATIENT_BUTTONS.includes(key)) return redirect('../');
    return true;
};